// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "index") return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}